module.exports = __webpack_public_path__ + "img/down-yn2.5bfb52df.png";